import styles from './NewPostitionButton.module.scss';

import PushPinIcon from '@mui/icons-material/PushPin';
import { Box, IconButton } from '@mui/material';

import { useSetting } from '@work4all/data/lib/settings/use-setting';

import { erpPinnedActions } from '../../../../../../../../../../settings/settings';

export const PinnedItem = ({ id: key, title, icon, renderPin }) => {
  const settings = useSetting(erpPinnedActions());
  const isPinned = settings.value.includes(key);
  return (
    <Box
      display="flex"
      gap="0.75rem"
      alignItems="center"
      flex="1"
      justifyContent="space-between"
      className={styles.nestedItemWrapper}
    >
      <Box display="flex" gap="0.75rem" alignItems="center">
        {icon}
        {title}
      </Box>

      {renderPin && (
        <IconButton
          className={!isPinned && styles.nestedItemWrapperIcon}
          size="small"
          style={{ padding: 0 }}
          onClick={(e) => {
            // Stop propagation to pickker - we want only click PIN BUTTON
            e.stopPropagation();
            // Toggle actionKey in settings.value
            const current = settings.value;
            if (current.includes(key)) {
              settings.set(current.filter((k) => k !== key));
            } else {
              settings.set([...current, key]);
            }
          }}
        >
          <PushPinIcon color={isPinned ? 'warning' : 'secondary'} />
        </IconButton>
      )}
    </Box>
  );
};
